import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterLeistungKundePipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'filterLeistungKundePipe',
})
export class FilterLeistungKundePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any, kunde:string) {
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-leistung-kunde/filter-leistung-kunde.ts